import type { Student } from "@/lib/student.schema";

interface BonusPriorityScoresProps {
	student: Student;
	/** Hiện khi chưa có giá trị — "-" ở hầu hết phương thức, "0" ở ĐGNL và UTX. */
	placeholder?: string;
}

/**
 * Tạm ẩn điểm cộng và điểm ưu tiên khỏi thẻ sinh viên.
 *
 * Đổi thành `true` để hiện lại — đó là toàn bộ việc phải làm, không cần đụng
 * năm phương thức xét tuyển đang dùng component này.
 *
 * Chỉ ẩn khỏi màn hình. Hai giá trị vẫn nằm trong phản hồi của API và vẫn tới
 * trình duyệt; muốn thật sự không cho đọc thì phải cắt ở phía server.
 */
const SHOW_BONUS_PRIORITY = false;

/**
 * Hai ô điểm cộng / điểm ưu tiên.
 *
 * Khi ẩn thì không render gì cả và cũng không giữ chỗ — khoảng trắng giữa các
 * khối do `space-y-2` của thẻ cha tạo ra, nên trả `null` là các khối còn lại tự
 * khít vào nhau, không để lại lỗ hổng.
 */
export default function BonusPriorityScores({
	student,
	placeholder = "-",
}: BonusPriorityScoresProps) {
	if (!SHOW_BONUS_PRIORITY) return null;

	return (
		<div className="grid grid-cols-2 gap-2">
			<div className="text-center p-2 bg-purple-50 rounded-lg border">
				<div className="text-xl font-bold text-purple-600">{student.diem_cong || placeholder}</div>
				<div className="text-sm font-medium text-muted-foreground">Điểm cộng</div>
			</div>
			<div className="text-center p-2 bg-orange-50 rounded-lg border">
				<div className="text-xl font-bold text-orange-600">
					{student.diem_uu_tien || placeholder}
				</div>
				<div className="text-sm font-medium text-muted-foreground">Điểm ưu tiên</div>
			</div>
		</div>
	);
}
